import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';
import NewsCategoryModel from '@/models/NewsCategoryModel';

export default class NewsModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'news',
        tableName: 'news',
        label: 'News',
      },
      {
        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
          class: 'left',
        },

        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        avatar: {
          name: 'avatar',
          label: 'Cover',
          custom: 'image',
          type: 'Computed',
          computed: (data, index) => {
            data.avatar = index + 1;
          },
          // width: 11,
          class: 'left image-avatar',
        },

        short_description: {
          name: 'short_description',
          type: 'String',
          label: 'Short description',
          class: 'left',
          display: false,
        },

        description: {
          name: 'description',
          type: 'Text',
          label: 'Description',
          // class: 'large-col',
          // computed: (data) => {
          //   data.description = '';
          // },
          display: false,
        },

        url_video: {
          name: 'url_video',
          type: 'String',
          label: 'Url video',
          class: 'left',
          display: false,
        },

        name: {
          name: 'name',
          type: 'String',
          label: 'Title',
          filter: { type: 'input', match: 'contains' },
          class: 'left',
        },

        news_category_id: {
          name: 'news_category_id',
          label: 'Category',
          type: 'String',
          models: new NewsCategoryModel(),
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'left',
          // computed: (data) => {
          //   data.news_category_id = '';
          // },
          width: 8,
        },

        type_category: {
          name: 'type_category',
          label: 'Type category',
          type: 'Computed',
          computed: (data) => {
            data.type_category = 0;
          },
          display: false,
        },

        ordinal: {
          name: 'ordinal',
          type: 'Number',
          label: 'Order',
          width: 10,
          class: 'ordinal-css',
        },

        active: {
          name: 'active',
          label: 'Active',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 'true', label: 'Yes', style: 'color:  #000000;' },
            { value: 'false', label: 'No', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'active-css',
          width: 8,
        },

        slug: {
          name: 'slug',
          label: 'Slug',
          type: 'String',
          display: false,
        },

        type_product: {
          name: 'type_product',
          label: 'Type product',
          type: 'SmallInt',
          display: false,
        },

        type: {
          name: 'type',
          label: 'Type',
          type: 'SmallInt',
          display: false,
        },

        website: {
          name: 'website',
          label: 'Website',
          type: 'Boolean',
          display: false,
        },

        app: {
          name: 'app',
          label: 'App',
          type: 'Boolean',
          display: false,
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_by_key: {
          name: 'updated_by_key',
          label: 'Updated by',
          type: 'Computed',
          models: new UserModel(),
          computed: (data) => {
            data.updated_by_key = '';
          },
          class: 'left',
          width: 15,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          width: 15,
          class: 'left',
        },

        created_at: {
          name: 'created_at',
          type: 'Datetime',
          label: 'Created At',
          display: false,
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },
        detail_get: {
          refs:  ' alt  ',
          display: false
      },
      }
    );
  }
}
